import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import axios from "../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../utils/adminConfig";
import { Members } from "../../assets/images";
import { useParams } from "react-router-dom";
import "../admin-dashboard/memberdetails/bulkuploadmember.css";
import ignite_example from "../../assets/ignite_example.csv";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useHistory } from "react-router-dom";
const ClientWiseMemberUpload = () => {
  const history = useHistory();
  const { clientId, tviId } = useParams()
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [clientDetails, setClientDetails] = useState(null);

  const getClientDetails = () => {
    axios.get(`/user/${tviId}`).then((res) => {
      if (res.data.status) {
        setClientDetails(res.data.data);
      }
    })
  }
  useEffect(() => {
    getClientDetails();
  }, [tviId]);


  const uploadBadge = async (e) => {
    e.preventDefault();
    if (!clientId) {
      message.error("Please select a client");
      return;
    }
    if (!file) {
      message.error("Please upload file");
      return;
    }
    setLoading(true);
    let data = new FormData();
    data.append("csv", file);

    await axios
      .post(`/corporate-client/ignite-member-csv-upload/${clientId}`, data, adminConfig())
      .then((res) => {
        setLoading(false);

        if (res.data.status === true) {
          message.success(res.data.message || "added members success");
          setFile("");
          // Clear input file
          document.getElementById('csvFileInput').value = '';
        } else {
          message.error(res.data.message || "failed adding members");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        message.error(err?.response?.data?.message || "Something went wrong!");
      });
  };

  return (
    <div className="right_cont">
      <div className="right_banner_banner_cnt">
        <div className="travel_deals_admin">
          <LoadingOverlay active={loading} spinner text="loading...">
            <div className="add_certificate">
              <Button
                variant="dark"
                onClick={() => history.goBack()}
              >
                <IoMdArrowRoundBack />
                Go Back
              </Button>
              <h3>Member Upload - {clientDetails?.name}</h3>


              <a type="button" href={ignite_example} download className="sample_download_button_csv">
                Click here to Download Sample CSV Template
              </a>

              <span>Only CSV file supported</span>
              <div className="addcert_box1">
                <Row>
                  <Col lg="12" md="12" sm="12">

                    <Form.Group className="mb-3">
                      <div className="upload_btn_wrapper mt-3">
                        <button className="btn_bulk">
                          <span className="cert_bulkks">
                            <img src={Members} alt="" />
                          </span>
                          {file !== "" ? file.name : "Upload Members"}
                        </button>
                        <input
                          type="file"
                          id="csvFileInput"
                          name="myfile"
                          accept=".csv"
                          onChange={(e) => {
                            setFile(e.target.files[0]);
                          }}
                        />
                      </div>
                    </Form.Group>

                    <div className="sub_but">
                      <button
                        type="button"
                        className="add_but submit_buttt mt-0"
                        onClick={uploadBadge}
                      >
                        Submit
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </LoadingOverlay>
        </div>
      </div>
    </div>
  );
};

export default ClientWiseMemberUpload;
